import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function useAuth() {

  const navigate = useNavigate();

  const [databaseName, setDatabase] = useState(null);
  const [userName, setUsername] = useState(null);
  const [clientName, setCliente] = useState(null);

  useEffect(() => {

    const verifySession = async () => {

      try {

        const response = await fetch(
          "api/verifySession.php",
          {
            method: "GET",
            credentials: "include"
          }
        );

        if (response.status === 401) {

          localStorage.clear();

          alert("Sesión expirada");

          navigate("/");

          return;
        }

        const data = await response.json();

        if (!data.success) {

          localStorage.clear();

          navigate("/");

          return;
        }

        setDatabase(data.client_db);
        setCliente(data.client_name);

        const storedUsername =
          localStorage.getItem("userName");

        setUsername(storedUsername);

      } catch (error) {

        console.error(error);

        localStorage.clear();

        navigate("/");
      }
    };

    verifySession();

  }, [navigate]);

  return {
    databaseName,
    userName,
    clientName
  };
}